// import SplashNetworksCell from '@/components/splashes/SplashNetworksCell.vue'
import type { SplashResponse } from '@/services/splashes-v2-service/types'
// import { Badge } from 'primevue'
// import { markRaw } from 'vue'

import type { TableColumn } from '@/components/alerts/types'
import { getTradeUrl } from '@/utils'

export const getSplashesColumns = (): TableColumn[] => {
  return [
    {
      field: 'symbol',
      width: '120px',
      header: 'table.asset',
      class: 'text-center',
      dynamic: true,
      inner: 'a',
      innerPropsGenerator: (v: object) => {
        const data = v as SplashResponse
        const asset = data.symbol.split('/')[0] as string
        const href = getTradeUrl(data.exchange, asset, true)
        return {
          target: '_blank',
          href: href,
          class: 'pit hover',
        }
      },
    },
    {
      field: 'exchange',
      width: '110px',
      header: 'exchange',
      class: 'text-center',
      inner: 'span',
      innerProps: {
        class: 'pit table-asset success',
      },
    },
    {
      field: 'grp',
      width: '100px',
      header: 'movement',
      class: 'text-center',
      inner: 'span',
      sortable: true,
      innerProps: {
        class: 'pit digit success',
      },
    },
    {
      field: 'total_2h',
      width: '110px',
      header: 'splashes1Count',
      class: 'text-center',
      inner: 'span',
      sortable: true,
      dynamic: true,
      innerPropsGenerator: (v: object) => {
        const data = v as SplashResponse
        let myClass = ''
        if (data.total_2h == 0) {
          myClass = 'error'
        } else if (data.total_2h <= 10) {
          myClass = 'warn'
        } else {
          myClass = 'success'
        }
        return {
          class: `pit digit ${myClass}`,
        }
      },
    },
    // {
    //   field: 'total_12h',
    //   header: 'splashes12Count',
    //   class: 'text-center',
    //   inner: 'span',
    //   sortable: true,
    //   dynamic: true,
    //   innerPropsGenerator: (v: object) => {
    //     const data = v as SplashResponse
    //     let myClass = ''
    //     if (data.total_12h == 0) {
    //       myClass = 'error'
    //     } else if (data.total_12h <= 10) {
    //       myClass = 'warn'
    //     } else {
    //       myClass = 'success'
    //     }
    //     return {
    //       class: `pit digit ${myClass}`,
    //     }
    //   },
    // },
    {
      field: 'total_24h',
      width: '110px',
      header: 'splashes24Count',
      class: 'text-center',
      sortable: true,
      inner: 'span',
      dynamic: true,
      innerPropsGenerator: (v: object) => {
        const data = v as SplashResponse
        let myClass = ''
        if (data.total_24h == 0) {
          myClass = 'error'
        } else if (data.total_24h <= 10) {
          myClass = 'warn'
        } else {
          myClass = 'success'
        }
        return {
          class: `pit digit ${myClass}`,
        }
      },
    },
    {
      field: 'last_signal_ts',
      width: '230px',
      header: 'lastSignalTs',
      class: 'text-center',
      inner: 'span',
      innerProps: {
        class: 'pit success digit',
      },
    },
    // {
    //   field: 'networks',
    //   header: 'networks',
    //   class: 'text-center',
    //   dynamic: true,
    //   inner: markRaw(SplashNetworksCell),
    //   innerPropsGenerator: (data: object) => {
    //     const sdata = data as SplashResponse
    //     return {
    //       exchange: sdata.exchange,
    //       symbol: sdata.symbol,
    //       chains: sdata.chains,
    //     }
    //   },
    // },
  ]
}
